import React from 'react';

import { CheckoutScreen } from '@fhs/cart';
import { Payment } from '@fhs-legacy/frontend/src/pages/cart/payment/order-payment/payment';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';

export default function CartPaymentPage() {
  const enableFreshCheckout = useFlag(LaunchDarklyFlag.CHECKOUT_PAGE_WITH_FRESH_UPDATE);

  return enableFreshCheckout ? <CheckoutScreen /> : <Payment />;
}
